import type { Produto } from '../../db/tipos'
import { percentualFiscal } from '../../produtos/textoFiscal'
import { IconeCaixa, IconeDocumento, IconeMoedas, IconePorcento } from './IconesDaFicha'

function Campo(props: { icone: React.ReactNode; rotulo: string; valor: string; legenda?: string | null }) {
  return (
    <div className="flex gap-2 py-2 border-t border-slate-100">
      <span className="text-teal-700 shrink-0" aria-hidden="true">{props.icone}</span>
      <div className="min-w-0">
        <p className="text-xs text-slate-500">{props.rotulo}</p>
        <p className="text-base font-bold text-slate-900">{props.valor}</p>
        {props.legenda && <p className="text-xs text-slate-500">{props.legenda}</p>}
      </div>
    </div>
  )
}

// A aba Dados Fiscais no modo de VER (print dela, 23/09). So os 5 campos que
// existem no banco; CST/CEST/CFOP/unidade tributavel ficam para o ciclo dos
// campos novos (spec §4b).
export default function AbaFiscalVendo({ produto }: { produto: Produto }) {
  return (
    <div className="space-y-3">
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-3">
        <p className="flex items-center gap-2 text-sm font-semibold text-slate-800 mb-1">
          <span className="text-teal-700" aria-hidden="true"><IconeDocumento /></span>Informações fiscais
        </p>
        <div className="grid grid-cols-2 gap-x-3">
          <Campo icone={<IconeCaixa />} rotulo="NCM" valor={(produto.ncm ?? '').trim() || 'não informado'} />
          <Campo icone={<IconePorcento />} rotulo="IPI" valor={percentualFiscal(produto.ipi_pct)} />
          <Campo icone={<IconePorcento />} rotulo="ICMS" valor={percentualFiscal(produto.icms_pct)} />
          <Campo icone={<IconePorcento />} rotulo="ST" valor={percentualFiscal(produto.st_pct)} />
          <Campo icone={<IconeMoedas />} rotulo="PIS/COFINS" valor={percentualFiscal(produto.pis_cofins_pct)} />
        </div>
      </div>
      <p className="text-xs text-slate-600 bg-sky-50 rounded-lg px-3 py-2">
        Dados conforme informados pela fábrica. Conferir com o contador.
      </p>
    </div>
  )
}
